<template>
  <v-list-item
    :href="item.href"
    :rel="item.href ? 'nofollow' : undefined"
    :target="item.href ? '_blank' : undefined"
    :to="item.to"
    active-class="primary white--text"
    link
    class="aside-list-item py-1"
    :class="{'hide-on-mobile': item.hideOnMobile}"
    :title="collapsed ? item.title : undefined"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list-item-icon v-if="item.icon" class="align-self-center">
      <span class="aside-list-item__icon-wrap">
        <font-awesome-icon :icon="item.icon" />
        <sidebar-badge :badge="badge" />
      </span>
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <v-list-item-title v-text="item.title" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  import SidebarBadge from './SidebarBadge.vue'

  export default {
    name: 'DefaultListItem',
    components: { SidebarBadge },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      collapsed: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      // Бадж на правом верхнем углу иконки. Пока единственный источник -
      // стоп-лист: знак СТОП при полном стопе филиала, иначе счётчик блюд
      badge () {
        if (this.item.badge !== 'stopList') {
          return null
        }

        if (this.$store.getters['stopList/getFilialStop']) {
          return { type: 'stop' }
        }

        const count = this.$store.getters['stopList/getStopCount']
        return count > 0 ? { type: 'count', value: count } : null
      },
    },
  }
</script>

<style lang="less" scoped>
  //noinspection ALL
  .aside-list-item {
    padding: 0 28px;
    height: 73px;
    width: 100%;
    justify-content: left;
    border-radius: 0;
    background-color: transparent !important;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #191919 !important;

      .v-list-item__title {
        color: @color-primary;
      }

      svg {
        ::v-deep {
          .fill-svg(@color-primary);
        }
      }
    }

    &.v-list-item--active {
      background-color: #191919 !important;

      .v-list-item__title {
        color: @color-primary;
      }

      svg {
        ::v-deep {
          .fill-svg(@color-primary);
        }
      }
    }

    .v-list-item__icon {
      margin: 0 40px 0 0;
      height: 100%;
    }

    // Якорь для баджа на правом верхнем углу иконки
    .aside-list-item__icon-wrap {
      position: relative;
      display: flex;
      align-items: center;
      height: 100%;
    }

    svg {
      height: 100%;
      width: 50px;

      ::v-deep {
        .fill-svg(#ffffff);
      }
    }

    .v-list-item__title {
      font-size: 24px;
      text-align: left;
      flex: 1;
      transition: color 0.2s ease;
    }

    // .media-xl-max({
      padding: 0 22px;
      height: 55px;
      margin-bottom: 3px !important;

      .v-list-item__icon {
        margin: 0 30px 0 0;
      }

      svg {
        width: 35px;
      }

      .v-list-item__title {
        font-size: 18px;
      }

    // });

    // Свёрнутый сайдбар компактного десктопа: только иконка по центру полоски
    .navigation-drawer-component--collapsed & {
      padding: 0;
      justify-content: center;

      .v-list-item__icon {
        margin: 0;
      }

      .v-list-item__content {
        display: none;
      }
    }
  }
</style>
